import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignIdParams from './CampaignIdParams';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedCampaignIdParams = connect(
  mapStateToProps, null,
)(CampaignIdParams);

export default withTranslation(['administration'])(ConnectedCampaignIdParams as any);
